module.exports = "assets/img/pavillon_rene_greisch.jpg";